












export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bars: [10, 10, 10, 10, 10]
    }
  },
  methods: {
    barHeight (bar: number): string {
      // Ensure bars array exists
      if (!Array.isArray(this.bars) || this.bars.length !== 5) {
        // initialize with default heights
        this.bars = [10, 10, 10, 10, 10]
      }

      // When active, keep a short interval that updates bars to random heights
      if (this.active) {
        if (!this._audioBarsInterval) {
          this._audioBarsInterval = setInterval(() => {
            for (let i = 0; i < this.bars.length; i++) {
              // random height between 8 and 38 px (tweak as desired)
              this.bars.splice(i, 1, 8 + Math.round(Math.random() * 30))
            }
          }, 150) // update every 150ms for a "talking" effect
        }
        return `${this.bars[bar - 1]}px`
      }

      // Inactive: stop the animation and show a default height
      if (this._audioBarsInterval) {
        clearInterval(this._audioBarsInterval)
        this._audioBarsInterval = null
        // reset to default heights
        this.bars = [10, 10, 10, 10, 10]
      }
      return '10px'
    }
  }
}
